import React from 'react';
import UtilitiesController from './utilitiesController';
import AuthController from './authController';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

export default class AnalyticsController {

    static exceptionWrapper = (fn) => async (data) => {
        try {
            return await fn(data).catch((err) => {
                throw err;
            });
        } catch (err) {
            return {
                success: false,
                error: err.app_error ? err.app_error : err.message
            }
        }
    };

    static updateMobileSession = AnalyticsController.exceptionWrapper(async (params) => {

      if (params.start_state && params.start_state === 'LAUNCHED') {
        await AsyncStorage.setItem("mobile_session_id", '');
      }

      // LOOK INTO DEVICE SPECIFIC ID

      let saved_app_instance_id   = await AsyncStorage.getItem('app_instance_id');
      let saved_mobile_session_id = await AsyncStorage.getItem('mobile_session_id');
      let saved_user_id           = await AsyncStorage.getItem('user_id');

      if (params && params.has_ended === true && !saved_mobile_session_id) {
        return;
      }

      let request_data = {
        mobile_session_id: saved_mobile_session_id || '',
        app_instance_id: saved_app_instance_id || '',
        platform: Platform.OS,
        has_ended: params.has_ended === true ? true : false,
        user_id: saved_user_id || '',
        partner_name: 'dodowell',
        start_state: params.start_state || 'REOPENED'
      }

      let response = await UtilitiesController.post('/v4/update_mobile_session', request_data, true);

      let app_instance_id   = response && response.success && response.app_instance   ?  response.app_instance._id   : saved_app_instance_id;
      let mobile_session_id = response && response.success && response.mobile_session ?  response.mobile_session._id : saved_mobile_session_id;
          mobile_session_id = response && response.success && response.mobile_session && response.mobile_session.end_time ? '' : mobile_session_id;

      if (!saved_app_instance_id) {
        await AsyncStorage.setItem("app_instance_id", app_instance_id);
      }

      await AsyncStorage.setItem("mobile_session_id", mobile_session_id);

      return response;
    });

    static updateSessionLatestPing = AnalyticsController.exceptionWrapper(async (params) => {
      let saved_mobile_session_id = await AsyncStorage.getItem('mobile_session_id');
      let saved_user_id           = await AsyncStorage.getItem('user_id');

      let request_data = {
        mobile_session_id: saved_mobile_session_id || '',
        user_id: saved_user_id || ''
      }

      let response = await UtilitiesController.post('/v4/update_mobile_session_ping', request_data, true);

      return response;
    });

    static updateArticleEngagement = AnalyticsController.exceptionWrapper(async (params) => {
      let saved_mobile_session_id = await AsyncStorage.getItem('mobile_session_id');
      let saved_user_id           = await AsyncStorage.getItem('user_id');

      let request_data = {
        mobile_session_id: saved_mobile_session_id || '',
        user_id: saved_user_id || '',
        category_tags: params.category_tags || [],
        article_id: params.article_id || '',
        article_url: params.article_url || '',
        article_engagement_id: params.article_engagement_id || '',
        has_closed: params.has_closed
      }

      let response = await UtilitiesController.post('/v4/update_article_engagement', request_data, true);

      return response;
    });
}
